<svg viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 1l4 4-4 4" stroke="currentColor" stroke-linecap="round"></path>
</svg>